import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';
import { LoadingIndicator } from '../loading-indicator';

export type ButtonTypes = {
  primary: never;
  secondary: never;
  danger: never;
};

export type ButtonType = keyof ButtonTypes;

export type ButtonProps = {
  buttonType?: ButtonType;
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'size'>;

export const Button = forwardRef(
  (
    {
      buttonType = 'primary',
      size = 'medium',
      children,
      className,
      loading,
      disabled,
      ...props
    }: ButtonProps,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    const theme = useTheme();
    const classNames = classnames(
      className,
      'airtame-button',
      `airtame-button--${buttonType}`,
      `airtame-button--${size}`
    );

    const disabledOrLoading = disabled || loading;

    return (
      <button
        className={classNames}
        data-theme={theme}
        ref={ref}
        disabled={disabledOrLoading}
        {...props}
      >
        {children}
        {loading && (
          <span className="airtame-button__loading-overlay">
            <LoadingIndicator className="airtame-button__loading-indicator" />
          </span>
        )}
      </button>
    );
  }
);

Button.displayName = 'Button';
